import { ComponentTypeEnum } from "@/graphql";

export const DETAILS_PROGRAM_TABS = [
  {
    key: "details",
    label: "Overview",
    linkTo: "/programs/{id}/details",
  },
  {
    key: "surveys",
    label: "Surveys",
    linkTo: "/programs/{id}/surveys",
    linkSurvey: "/programs/{id}/surveys/{componentId}",
    linkResponse: "/programs/{id}/surveys/{componentId}/{responseId}",
    addButtonText: "Add Survey",
    componentType: ComponentTypeEnum.Survey,
  },
  {
    key: "action-items",
    label: "Action Items",
    linkTo: "/programs/{id}/action-items",
    linkSurvey: "/programs/{id}/action-items/{componentId}",
    linkResponse: "/programs/{id}/action-items/{componentId}/{responseId}",
    addButtonText: "Add Action Items",
    componentType: ComponentTypeEnum.ActionItem,
  },
  {
    key: "ai-roleplays",
    label: "Roleplays",
    linkTo: "/programs/{id}/ai-roleplays",
    linkSurvey: "/programs/{id}/ai-roleplays/{componentId}",
    linkResponse: "/programs/{id}/ai-roleplays/{componentId}/{responseId}",
    addButtonText: "Add Roleplay",
    componentType: ComponentTypeEnum.AiRoleplay,
  },
  {
    key: "videos",
    label: "Videos",
    linkTo: "/programs/{id}/videos",
    linkSurvey: "/programs/{id}/videos/{componentId}",
    linkResponse: "/programs/{id}/videos/{componentId}/{responseId}",
    addButtonText: "Add Video",
    componentType: ComponentTypeEnum.Video,
  },
  {
    key: "articles",
    label: "Articles",
    linkTo: "/programs/{id}/articles",
    linkSurvey: "/programs/{id}/articles/{componentId}",
    linkResponse: "/programs/{id}/articless/{componentId}/{responseId}",
    addButtonText: "Add Article",
    componentType: ComponentTypeEnum.Article,
  },
  {
    key: "announcement",
    label: "Announcement",
    linkTo: "/programs/{id}/announcement",
    linkSurvey: "/programs/{id}/announcement/{componentId}",
    linkResponse: "/programs/{id}/announcement/{componentId}/{responseId}",
    addButtonText: "Add Announcement",
    componentType: ComponentTypeEnum.Announcement,
  },
  {
    key: "group-meetings",
    label: "Group Meetings",
    linkTo: "/programs/{id}/group-meetings",
    linkSurvey: "/programs/{id}/group-meetings/{componentId}",
    linkResponse: "/programs/{id}/group-meetings/{componentId}/{responseId}",
    addButtonText: "Add Group Meeting",
    componentType: ComponentTypeEnum.GroupMeeting,
  },
  {
    key: "one-one-coaching",
    label: "1:1 Coaching",
    linkTo: "/programs/{id}/one-one-coaching",
    linkSurvey: "/programs/{id}/one-one-coaching/{componentId}",
    linkResponse: "/programs/{id}/one-one-coaching/{componentId}/{responseId}",
    addButtonText: "Add 1:1 Coaching",
    componentType: ComponentTypeEnum.OneOneCoachingMaster,
  },
];
